import { render, staticRenderFns } from "./profitImpact2.vue?vue&type=template&id=ca67dc54&scoped=true&"
import script from "./profitImpact2.vue?vue&type=script&lang=js&"
export * from "./profitImpact2.vue?vue&type=script&lang=js&"
import style0 from "./profitImpact2.vue?vue&type=style&index=0&id=ca67dc54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca67dc54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
